import ShopCategoryModelBase from '../_generated/modelBases/shop-category-model-base';

export default class ShopCategoryModel extends ShopCategoryModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
